const redirectAcesso = async ({ next, router, to, store }) => {
  const aluno = store.state.rematricula.aluno;
  const rematricula = store.state.rematricula.rematricula;

  if (!rematricula || !aluno) {
    return router.push(`/rematricula/inicio`);
  }

  const matricula = {
    codigoCurso: aluno.curso.codigo,
    nome: aluno.curso.nome,
    habilitacaoFilial: rematricula.rem_rematricula_corpore.habilitacaoFilial,
    perletivo: rematricula.rem_rematricula_corpore.perletivo,
    codigoPeriodoLetivo: null,
    codigoStatus: rematricula.rem_configuracao.codStatusEntrada
  };

  await store.dispatch("alteracaoMatricula/setAluno", aluno);
  await store.dispatch("alteracaoMatricula/setMatricula", matricula);
  await store.dispatch("alteracaoMatricula/setRematricula", rematricula);

  return next();
};

export default redirectAcesso;



// WEBPACK FOOTER //
// ./src/middleware/rematricula/carregaSelecaoDisciplinas.js